module.exports = __webpack_public_path__ + "03_very_short_black.2e33c15d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_very_short_black.png
// module id = byAU
// module chunks = 0